import React from "react";
import { Modal } from "react-bootstrap";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";

import { getAllCity, getAllDistrictOfCity, getAllWardOfDistrict } from "../../model/common";
import { parseAddressToLocation, parseAddressToLocationWithLatLng } from "../common/wdfunction";

import { commonErr } from "./errors";

import CarMapLocation from "../car/components/carmaplocation";

// import user_delivery from "../../static/images/marker-delivery-2.png"
import { mapSdk } from "../../model/base";
import HereAutoComplete from "./hereautocomplete";

export const FormMyAddress = ({
	cities,
	locCity,
	districts,
	wards,
	cityId,
	districtId,
	wardId,
	address,
	locAddress,
	onCitySelectChange,
	onDistrictSelectChange,
	onWardSelectChange,
	onAddressChange,
	onAddressFocus,
	onSelectFromAddress,
}) => {
	return (
		<React.Fragment>
			<div className="three-item">
				<div className="address-type">
					<div className="type-title">
						<p>Thành phố</p>
					</div>
					<div className="custom-select">
						<select name="cityId" value={cityId} onChange={(e) => onCitySelectChange(e)}>
							<option value="0">Chọn thành phố</option>
							{cities &&
								cities.map((city) => (
									<option key={city.id} value={city.id * 1}>
										{city.name}
									</option>
								))}
						</select>
					</div>
				</div>
				<div className="address-type">
					<div className="type-title">
						<p>Quận&nbsp;/&nbsp;Huyện</p>
					</div>
					<div className="custom-select">
						<select
							name="districtId"
							value={districtId}
							disabled={!cityId || cityId === 0}
							onChange={(e) => onDistrictSelectChange(e)}>
							<option value="0">{!cityId || cityId === 0 ? "Chọn thành phố trước" : "Chưa chọn"}</option>
							{districts &&
								districts.map((district) => (
									<option key={district.id} value={district.id * 1}>
										{district.name}
									</option>
								))}
						</select>
					</div>
				</div>
				<div className="address-type">
					<div className="type-title">
						<p>Phường&nbsp;/&nbsp;Xã</p>
					</div>
					<div className="custom-select">
						<select
							name="wardId"
							value={wardId}
							disabled={!districtId || districtId === 0}
							onChange={(e) => onWardSelectChange(e)}>
							<option value="0">{!districtId || districtId === 0 ? "Chọn quận huyện trước" : "Chưa chọn"}</option>
							{wards &&
								wards.map((ward) => (
									<option key={ward.id} value={ward.id * 1}>
										{ward.name}
									</option>
								))}
						</select>
					</div>
				</div>
			</div>
			<div className="address-type">
				<div className="type-title">
					<p>Địa chỉ</p>
				</div>
				<div className="custom-input">
					<div className="wrap-input">
						<HereAutoComplete
							theme="LIGHT"
							inputProps={{
								value: address,
								onChange: onAddressChange,
								onFocus: onAddressFocus,
								placeholder: "Nhập tên đường / tòa nhà",
							}}
							onSelect={(address) => onSelectFromAddress(address)}
						/>
					</div>
				</div>
			</div>

			{locAddress !== null && wardId > 0 && (
				<CarMapLocation location={{ lat: locAddress.lat, lon: locAddress.lng }} twoMap={true} />
			)}
		</React.Fragment>
	);
};

export const FormAddress = ({
	cities,
	locCity,
	districts,
	wards,
	cityId,
	districtId,
	wardId,
	address,
	locAddress,
	onCitySelectChange,
	onDistrictSelectChange,
	onWardSelectChange,
	onAddressChange,
	onAddressFocus,
	onSelectFromAddress,
}) => {
	return (
		<React.Fragment>
			<div className="line-form">
				<div className="custom-input">
					<div className="wrap-info">
						<div className="title-status">
							<p>Tỉnh/ Thành phố</p>
						</div>
					</div>
					<div className="wrap-select">
						<select name="cityId" value={cityId} onChange={(e) => onCitySelectChange(e)}>
							<option value={0}>Chọn thành phố</option>
							{cities &&
								cities.map((city) => (
									<option key={city.id} value={city.id * 1}>
										{city.name}
									</option>
								))}
						</select>
					</div>
				</div>
			</div>
			<div className="line-form">
				<div className="custom-input">
					<div className="wrap-info">
						<div className="title-status">
							<p>Quận/ Huyện</p>
						</div>
					</div>
					<div className="wrap-select">
						<select
							name="districtId"
							value={districtId}
							disabled={!cityId || cityId === 0}
							onChange={(e) => onDistrictSelectChange(e)}>
							<option value={0}>{!cityId || cityId === 0 ? "Chọn thành phố trước" : "Chưa chọn"}</option>
							{districts &&
								districts.map((district) => (
									<option key={district.id} value={district.id * 1}>
										{district.name}
									</option>
								))}
						</select>
					</div>
				</div>
			</div>
			<div className="line-form">
				<div className="custom-input">
					<div className="wrap-info">
						<div className="title-status">
							<p>Phường/ Xã</p>
						</div>
					</div>
					<div className="wrap-select">
						<select
							name="wardId"
							value={wardId}
							disabled={!districtId || districtId === 0}
							onChange={(e) => onWardSelectChange(e)}>
							<option value={0}>{!districtId || districtId === 0 ? "Chọn quận huyện trước" : "Chưa chọn"}</option>
							{wards &&
								wards.map((ward) => (
									<option key={ward.id} value={ward.id * 1}>
										{ward.name}
									</option>
								))}
						</select>
					</div>
				</div>
			</div>
			<div className="line-form">
				<div className="custom-input">
					<div className="wrap-info">
						<div className="title-status">
							<p>Đường</p>
						</div>
					</div>
					<div className="wrap-input">
						{mapSdk == 0 ? (
							<PlacesAutocomplete
								inputProps={{
									value: address,
									onChange: onAddressChange,
									onFocus: onAddressFocus,
									placeholder: "Nhập tên đường / tòa nhà",
								}}
								onSelect={(address) => onSelectFromAddress(address)}
								isUseCurrentLocation={true}
								googleLogo={false}
								options={{
									componentRestrictions: { country: ["vn"] },
									location: new window.google.maps.LatLng(locCity),
									radius: 10,
									strictbounds: true,
									types: ["address"],
								}}
							/>
						) : (
							<HereAutoComplete
								theme="LIGHT"
								inputProps={{
									value: address,
									onChange: onAddressChange,
									onFocus: onAddressFocus,
									placeholder: "Nhập tên đường / tòa nhà",
								}}
								onSelect={(address) => onSelectFromAddress(address)}
							/>
						)}
					</div>
				</div>
			</div>
			{locAddress !== null && wardId > 0 && (
				<CarMapLocation location={{ lat: locAddress.lat, lon: locAddress.lng }} twoMap={true} />
			)}
		</React.Fragment>
	);
};

class FormAddressBox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			addressName: "",
			cityId: 0,
			districtId: 0,
			wardId: 0,
			street: "",
			locAddress: null,
			address: "",
		};
	}
	componentDidMount() {
		getAllCity().then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.setState({
					cities: resp.data.data.cities,
				});
			}
		});
	}

	getAllDistrictOfCity = (cityId) => {
		getAllDistrictOfCity(cityId).then((resp) => {
			this.setState({
				districts: resp.data.data.districts,
			});
		});
	};

	getAllWardOfDistrict = (districtId) => {
		getAllWardOfDistrict(districtId).then((resp) => {
			this.setState({
				wards: resp.data.data.wards,
			});
		});
	};

	onCitySelectChange = (e) => {
		const cityId = e.target.value * 1;

		if (cityId > 0) {
			getAllDistrictOfCity(cityId).then((resp) => {
				if (resp.data.error >= commonErr.SUCCESS) {
					this.setState({
						cityId,
						districts: resp.data.data.districts,
					});
				}
			});
		} else {
			this.setState({
				cityId: 0,
				districtId: 0,
				wardId: 0,
			});
		}
	};

	onDistrictSelectChange = (e) => {
		const districtId = e.target.value * 1;
		if (districtId > 0) {
			getAllWardOfDistrict(districtId).then((resp) => {
				if (resp.data.error >= commonErr.SUCCESS) {
					this.setState({
						districtId,
						wards: resp.data.data.wards,
					});
				}
			});
		} else {
			this.setState({
				districtId: 0,
				wardId: 0,
			});
		}
	};

	onWardSelectChange = (e) => {
		const { cityId, districtId, cities, districts, wards } = this.state;
		const wardId = e.target.value * 1;
		this.setState({
			wardId,
		});

		let cityName;
		let districtName;
		let wardName;

		cities.filter((city) => {
			if (city.id === cityId) {
				cityName = city.name;
			}
		});
		districts.filter((district) => {
			if (district.id === districtId) {
				districtName = district.name;
			}
		});
		wards.filter((ward) => {
			if (ward.id === wardId) {
				wardName = ward.name;
			}
		});

		let address = `${wardName}, ${districtName}, ${cityName}`;

		// parseAddressToLocationWithLatLng(address.address, address.lat, address.lng, (locCity) => {
		this.setState({
			// locCity,
			addressName: address,
		});
		// })
	};

	onAddressFocus = () => {
		this.setState({
			address: "",
		});
	};

	onAddressChange = (address) => {
		if (address || address !== "") {
			parseAddressToLocationWithLatLng(address, address.lat, address.lon, (location) => {
				this.setState({
					locAddress: location,
				});
			});
		}

		this.setState({
			street: address,
		});
	};

	onSelectFromAddress = (address) => {
		if (address.err < 0) {
			var errMsg = "";
			if (address.err === -200) {
				errMsg =
					"Bạn đã không cho phép trình duyệt truy cập vị trí hiện tại. Vui lòng cài đặt cho phép hoặc nhập địa chỉ.";
			} else {
				errMsg = "Không thể tìm thấy vị trí hiện tại của thiết bị. Vui lòng thử lại hoặc nhập địa chỉ.";
			}
			this.setState({
				err: commonErr.FAIL,
				errMsg: errMsg,
			});
		} else if (address.err === commonErr.LOADING) {
			this.setState({
				err: commonErr.LOADING,
			});
		} else {
			parseAddressToLocationWithLatLng(address.address, address.lat, address.lng, (location) => {
				let street = address.address.split(",");

				this.setState({
					err: commonErr.SUCCESS,
					street: street[0],
					locAddress: location,
				});
			});
		}
	};

	isValidAddress = () => {
		const { locAddress, cityId, districtId, wardId, street } = this.state;
		return (
			cityId > 0 &&
			districtId > 0 &&
			wardId > 0 &&
			street !== "" &&
			locAddress &&
			locAddress.lat &&
			locAddress.lng &&
			locAddress.lat !== 0 &&
			locAddress.lng !== 0
		);
	};

	onUpdate = () => {
		const { locAddress, cityId, districtId, wardId, street, addressName } = this.state;
		let address = `${street}, ${addressName}`;

		const location = {
			address: address,
			lat: locAddress.lat,
			lng: locAddress.lng,
			cityId: cityId,
			districtId: districtId,
			wardId: wardId,
			street: street,
		};

		this.props.onUpdate(location);
		this.props.close();
	};

	close = () => {
		this.props.close();
	};

	render() {
		const { show } = this.props;
		const { cities, districts, wards, cityId, districtId, wardId, street, locAddress, locCity } = this.state;
		return (
			<Modal show={show} onHide={this.close} dialogClassName="modal-s modal-dialog modal-input">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Chỉnh sửa địa chỉ</h5>
				</Modal.Header>
				<Modal.Body>
					<div className="modal-input-body">
						<FormAddress
							cities={cities}
							districts={districts}
							wards={wards}
							cityId={cityId}
							districtId={districtId}
							wardId={wardId}
							address={street}
							locCity={locCity}
							locAddress={locAddress}
							onCitySelectChange={this.onCitySelectChange}
							onDistrictSelectChange={this.onDistrictSelectChange}
							onWardSelectChange={this.onWardSelectChange}
							onAddressChange={this.onAddressChange}
							onAddressFocus={this.onAddressFocus}
							onSelectFromAddress={this.onSelectFromAddress}
						/>
						<div className="wrap-btn has-2-btn">
							<a className="btn btn--m btn-primary" disabled={!this.isValidAddress()} onClick={this.onUpdate}>
								Áp dụng
							</a>
							<a className="btn btn-link" onClick={this.close}>
								Hủy bỏ
							</a>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		);
	}
}

export default FormAddressBox;
